import React, { FunctionComponent } from 'react'
import { CategoryArrow } from '/src/ui/shared/challengeProtocol/Arrow';
import { Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { theme } from "/src/assets/theme";
import smoothscroll from "smoothscroll-polyfill";
import { Protocol, ProtocolRecord } from '/src/domain/challenges/ChallengeProtocolData';

interface ProtocolHeaderProps {
    protocol: Protocol;
    records: ProtocolRecord[];
    isExpand: boolean;
    onClick: () => void;
    containerRef: React.RefObject<HTMLDivElement>;
}


export const ProtocolHeader: FunctionComponent<ProtocolHeaderProps> = ({ 
    protocol,
    records,
    isExpand,
    onClick,
    containerRef
}) => {
    const classes = useStyles()
    smoothscroll.polyfill()
    const handleClick = () => {
        onClick();
        containerRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    return (
        <Button variant={"contained"}
            fullWidth
            onClick={handleClick}
            className={classes.container}
            size={'large'}
        >
            {`${protocol.title} (${records.length})`}
            <CategoryArrow rotate={isExpand} />
        </Button>
    )
}

const useStyles = makeStyles({
    container: {
        backgroundColor: theme.lightSecondaryColor,
        padding: '0.5rem 1.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'start',
        lineHeight: '1rem',
        color: theme.secondaryColor,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: theme.lightSecondaryColor
        },
        '& svg': {
            minWidth: '1.5rem'
        }
    }
})
